import { useMutation, useQueryClient } from 'react-query';

import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface CreatePromptTemplateParameters {
  title: string;
  body: string;
}

export const useCreatePromptTemplate = (matterId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PromptTemplateResponseDto, Error, CreatePromptTemplateParameters>(
    async ({ title, body }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { title, body },
      });

      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}/prompt-template`, fetchConfig);

      if (!res.ok) {
        const errorBody = await res.json().catch(() => null);
        const message =
          (Array.isArray(errorBody?.message) ? errorBody.message[0] : errorBody?.message) ??
          'Creating prompt template failed';
        throw new Error(message);
      }
      return res.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.PromptTemplates, { matterId }]);
      },
    },
  );
};
